import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CModal, CModalHeader, CAccordion, CAccordionItem, CModalBody, CAccordionBody, CAccordionHeader, CModalTitle, CModalFooter, CButton } from '@coreui/react';
import { BsArrowRight, BsArrowBarDown } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import api from '../../../service/caller';
import choco from '../../../assets/images/choco.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getUserIdFromToken } from '../../../utils/authUtils';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { format } from "date-fns";
import { CFormInput } from '@coreui/react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import monday from '../billingmanagement/caisiere/pictures/momo.png'; // Mobile money icon
import money from '../billingmanagement/caisiere/pictures/Money.png'; // Card payment icon

const EditAppointmentModal = ({ visible, onClose, onAppointmentUpdated, appointmentData: initialAppointmentData }) => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [hospitalId, setHospitalId] = useState(null);
    const [message, setMessage] = useState('');
    const [appointmentInfo, setAppointmentInfo] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [specificDoctor, setSpecificDoctor] = useState(true);
    const [doctors, setDoctors] = useState([]);
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState('');
    const [patientIdinf, setpatientIdinf] = useState(null);
    const [doctorMessage, setDoctorMessage] = useState('');
    const [assignedDoctorMessage, setAssignedDoctorMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
    const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(false);
    const [showTimeSlots, setShowTimeSlots] = useState(false);
    const [appointmentData, setAppointmentData] = useState({
        patient_Name: '',
        hospitalId: '',
        motif: 'Consultation',
        type_consultation: '',
        department: '',
        price: '',
        notes: '',
        appointmentTime: '',
        appointmentDate: '',
        patientId: '',
        doctorId: '',
        appointmentEndTime: '',
    });
    const [originalAppointment, setOriginalAppointment] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    // Ajoutez ces états pour la gestion des pénalités
    const [showPenaltyWarningModal, setShowPenaltyWarningModal] = useState(false);
    const [penaltyAmount, setPenaltyAmount] = useState(0);
    const [systemSettings, setSystemSettings] = useState({
        modificationPenaltyPercentage: 15, // Valeur par défaut
        minimumModificationHours: 24 // Valeur par défaut
    });
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('mobile-money');
    const [phone, setPhoneNumber] = useState('');
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [cardNumber, setCardNumber] = useState('');
    const [cardExpiry, setCardExpiry] = useState('');
    const [cardCVC, setCardCVC] = useState('');

    // Ajoutez cet effet pour récupérer les paramètres du système
    useEffect(() => {
        const fetchSystemSettings = async () => {
            try {
                const response = await api.get('/clinic/system-settings');
                if (response.data) {
                    setSystemSettings({
                        modificationPenaltyPercentage: response.data.modificationPenaltyPercentage || 15,
                        minimumModificationHours: response.data.minimumModificationHours || 24
                    });
                }
            } catch (error) {
                console.error('Error fetching system settings:', error);
            }
        };
        
        fetchSystemSettings();
    }, []);

    // Charger les données initiales du rendez-vous
    useEffect(() => {
        if (initialAppointmentData && initialAppointmentData._id) {
            setIsLoading(true);
            console.log("Donnee",initialAppointmentData)
            
            // Formater les données du rendez-vous existant pour le formulaire
            const formattedTime = initialAppointmentData.appointmentTime 
                ? initialAppointmentData.appointmentTime.substring(0, 5) 
                : '';
                
            const formattedEndTime = initialAppointmentData.appointmentEndTime 
                ? initialAppointmentData.appointmentEndTime.substring(0, 5) 
                : '';
                
            setAppointmentData({
                _id: initialAppointmentData._id,
                patient_Name: initialAppointmentData.patient_Name || '',
                hospitalId: initialAppointmentData.hospitalId || '',
                motif: initialAppointmentData.motif || 'Consultation',
                type_consultation: initialAppointmentData.type_consultation || '',
                department: initialAppointmentData.department || '',
                price: initialAppointmentData.price || '',
                notes: initialAppointmentData.notes || '',
                appointmentTime: formattedTime,
                appointmentDate: initialAppointmentData.appointmentDate || '',
                patientId: initialAppointmentData.patientId || '',
                doctorId: initialAppointmentData.doctorId || '',
                appointmentEndTime: formattedEndTime,
                AppointmentCode: initialAppointmentData.AppointmentCode || '',
                paymentuniqueId: initialAppointmentData.paymentuniqueId || ''
            });
            
            setOriginalAppointment({...initialAppointmentData});
            setSelectedPatient(initialAppointmentData.patientId);
            
            // Déterminer si le médecin spécifique était sélectionné
            setSpecificDoctor(initialAppointmentData.specificDoctor || false);
            
            setIsLoading(false);
        }
    }, [initialAppointmentData]);

    // les information de l'utilisateur
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const response = await api.get('api/usersprofile');
                setUserData(response.data);
                const hospitalIds = response.data.hospital_id;

                if (hospitalIds && hospitalIds.length === 1) {
                    // Si un seul hôpital est présent, on le met dans l'état `hospitalId`
                    setHospitalId(hospitalIds[0]);
                } else {
                    // Si plusieurs hôpitaux sont présents, on laisse le champ sélectionnable
                    setHospitalId(null);
                }
                setUserRole(response.data.role.name);
                if (response.data.role.name == "medtinz_client_patient") {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setpatientIdinf(patientResponse.data);
                }
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // recuperer les docteur pour un departement 
    const fetchDoctors = async () => {
        try {
            const response = await api.get(`/api/getDoctorsByDepartment/${appointmentData.department}`);
            if (response.data && response.data.data) {
                setDoctors(response.data.data);
            } else {
                setDoctorMessage("Aucun médecin trouvé pour ce département.");
            }
        } catch (err) {
            console.error('Erreur détaillée:', err);
            setDoctorMessage(`Erreur lors du chargement des docteurs: ${err.message}`);
        }
    };

    // listes des departments
    useEffect(() => {
        if (UserData?.hospital_id && !departments.length) {
            fetchDepartments(UserData.hospital_id);
        }
    }, [UserData, departments]);

    // Utiliser useEffect pour appeler fetchDoctors dès que le département change
    useEffect(() => {
        if (appointmentData.department) {
            fetchDoctors();
        }
    }, [appointmentData.department]);

    const fetchDepartments = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }

        try {
            const response = await api.get(`/api/departments`, {
                params: { hospitalIds }
            });

            setDepartments(response.data.data);

        } catch (error) {
            console.error('Erreur lors de la récupération des départements:', error);
        }
    };

    const fetchAvailableTimeSlots = async (date) => {
        if (!date || !appointmentData.department) {
            return;
        }

        setIsLoadingTimeSlots(true);
        try {
            const allAvailableSlots = [];

            // Pour chaque médecin, récupérer ses disponibilités
            for (const doctor of doctors) {
                try {
                    const response = await api.get('/clinic/doctorAvailability', {
                        params: {
                            doctorId: doctor._id,
                            appointmentDate: date,
                            excludeAppointmentId: appointmentData._id, // Exclure le rendez-vous actuel
                        }
                    });

                    if (response.data && response.data.availableSlots && response.data.availableSlots.length > 0) {
                        // Ajouter les informations du médecin à chaque créneau disponible
                        const doctorSlots = response.data.availableSlots.map(slot => ({
                            ...slot,
                            doctorId: doctor._id,
                            doctorName: `Dr. ${doctor.firstname} ${doctor.lastname}`,
                            speciality: doctor.speciality || doctor.department?.name
                        }));

                        allAvailableSlots.push(...doctorSlots);
                    }
                } catch (error) {
                    console.error(`Erreur pour le médecin ${doctor._id}:`, error);
                }
            }

            // Trier les créneaux par heure de début
            allAvailableSlots.sort((a, b) => {
                if (a.start < b.start) return -1;
                if (a.start > b.start) return 1;
                return 0;
            });

            setAvailableTimeSlots(allAvailableSlots);

            if (allAvailableSlots.length === 0) {
                toast.info("Aucun créneau disponible pour cette date");
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des créneaux horaires:', error);
            toast.error("Impossible de récupérer les créneaux horaires disponibles");
            setAvailableTimeSlots([]);
        } finally {
            setIsLoadingTimeSlots(false);
        }
    };

    const selectTimeSlot = (slot) => {
        setAppointmentData(prev => ({
            ...prev,
            appointmentTime: slot.start,
            appointmentEndTime: slot.end,
            doctorId: slot.doctorId
        }));

        // Afficher les informations du médecin assigné
        setAssignedDoctorMessage(`Le rendez-vous sera assigné au médecin ${slot.doctorName}.`);
        setMessageType('success');
    };

    // gestion du formulaire
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'department') {
            // Trouver le département correspondant dans la liste des départements
            const selectedDepartment = departments.find(department => department._id === value);
            setAppointmentData({
                ...appointmentData,
                department: value,
                price: selectedDepartment ? selectedDepartment.price_consult : '',
            });
        } else {
            setAppointmentData({
                ...appointmentData,
                [name]: value
            });
        }
    };

    // Gérer le changement de date pour suggérer des horaires
    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        handleChange(e);

        // Reset appointment time when date changes
        setAppointmentData(prev => ({
            ...prev,
            appointmentDate: selectedDate,
            appointmentTime: ''
        }));

        // Fetch available time slots for the selected date
        if (selectedDate && appointmentData.department) {
            fetchAvailableTimeSlots(selectedDate);
        }
    };

    // Fonction pour calculer l'heure de fin d'un rdv
    const calculateEndTime = (startTime, durationInMinutes) => {
        const start = new Date(`1970-01-01T${startTime}:00Z`);
        const end = new Date(start.getTime() + durationInMinutes * 60000);
        const endTime = end.toISOString().substr(11, 5);
        return endTime;
    };

    // Fonction réutilisable pour vérifier la disponibilité des médecins
    const checkDoctorAvailability = async () => {
        // Vérifie que la date et l'heure sont sélectionnées avant de procéder
        if (!appointmentData.appointmentDate || !appointmentData.appointmentTime) {
            setAssignedDoctorMessage('Veuillez sélectionner une date et une heure.');
            setMessageType('danger');
            return false;
        }

        // Si la médecin et heure sont identiques à l'original, pas besoin de vérifier
        if (originalAppointment && 
            appointmentData.appointmentDate === originalAppointment.appointmentDate &&
            appointmentData.appointmentTime === originalAppointment.appointmentTime &&
            appointmentData.doctorId === originalAppointment.doctorId) {
            // Conserver le même médecin
            const doctor = doctors.find(doc => doc._id === appointmentData.doctorId);
            if (doctor) {
                setAssignedDoctorMessage(`Le rendez-vous restera assigné au médecin ${doctor.lastname} ${doctor.firstname}.`);
                setMessageType('success');
                return doctor;
            }
        }

        // Si la date ou l'heure sont sélectionnées, procéder à la vérification de la disponibilité
        let availableDoctors = [];

        try {
            // Calculer l'heure de fin du rendez-vous (par exemple, durée de 30 minutes)
            const appointmentDuration = 30;
            appointmentData.appointmentEndTime = calculateEndTime(appointmentData.appointmentTime, appointmentDuration);

            // Vérification de la disponibilité de chaque médecin
            availableDoctors = await Promise.all(doctors.map(async (doctor) => {
                const response = await api.get('/clinic/checkDoctorAvailability', {
                    params: {
                        doctorId: doctor._id,
                        appointmentDate: appointmentData.appointmentDate,
                        appointmentTime: appointmentData.appointmentTime,
                        appointmentEndTime: appointmentData.appointmentEndTime,
                        excludeAppointmentId: appointmentData._id, // Exclure le rendez-vous actuel
                    },
                });

                if (response.data.isAvailable) {
                    return doctor;
                } else {
                    return null;
                }
            }));

            availableDoctors = availableDoctors.filter(doctor => doctor !== null);

            if (availableDoctors.length > 0) {
                const doctor = availableDoctors[0];
                setAssignedDoctorMessage(`Le rendez-vous sera assigné au médecin ${doctor.lastname} ${doctor.firstname}.`);
                setMessageType('success');
                return doctor;
            } else {
                setAssignedDoctorMessage('Aucun médecin disponible pour ce créneau.');
                setMessageType('danger');
                return null;
            }
        } catch (error) {
            console.error('Erreur lors de la vérification des médecins:', error);
            setAssignedDoctorMessage('Erreur lors de la vérification des disponibilités.');
            setMessageType('danger');
            return null;
        }
    };

    // Gérer les changements de date ou d'heure
    const handleDateOrTimeChange = async () => {
        const assignedDoctor = await checkDoctorAvailability();
    };

    // Fonction pour formatter l'heure pour affichage
    const formatTimeForDisplay = (time) => {
        if (!time) return "";

        // Convert 24h format to AM/PM format
        const [hours, minutes] = time.split(':');
        const hr = parseInt(hours, 10);
        const ampm = hr >= 12 ? 'PM' : 'AM';
        const hr12 = hr % 12 || 12;

        return `${hr12}:${minutes} ${ampm}`;
    };

    useEffect(() => {
        if (hospitalId) {
            setAppointmentData((prevState) => ({
                ...prevState,
                hospitalId: hospitalId._id,
            }));
        }
    }, [hospitalId]);

    // metre a jour patient id 
    useEffect(() => {
        if (patientIdinf) {
            setAppointmentData((prevState) => ({
                ...prevState,
                patientId: patientIdinf._id,
            }));
        }
    }, [patientIdinf]);

    // Gérer la soumission du formulaire
    // Modifiez la fonction handleSubmit pour inclure la vérification des pénalités
// Modifiez la fonction handleSubmit pour inclure la vérification du type d'utilisateur
const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérifier si une pénalité doit être appliquée
    try {
        // Obtenir l'heure actuelle et l'heure du rendez-vous
        // const currentTime = new Date();
        // const appointmentTime = new Date(appointmentData.appointmentDate);
        
        // // Calculer la différence en heures
        // const hoursDifference = (appointmentTime - currentTime) / (1000 * 60 * 60);
        
        // // Vérifier si le rendez-vous est dans la période de pénalité ET si l'utilisateur est un patient
        // if (hoursDifference < systemSettings.minimumModificationHours && userRole === "medtinz_client_patient") {
        //     // Calculer le montant de la pénalité
        //     const appointmentPrice = appointmentData.price || 0;
        //     const calculatedPenalty = (appointmentPrice * systemSettings.modificationPenaltyPercentage) / 100;
            
        //     setPenaltyAmount(calculatedPenalty);
        //     setShowPenaltyWarningModal(true);
        //     return; // Arrêter le processus de soumission jusqu'à ce que la pénalité soit confirmée
        // } else {
            // Pas de pénalité ou utilisateur non patient, procéder à la modification normale
            await submitAppointmentModification(false, 0, false);
        // }
    } catch (error) {
        console.error('Error checking appointment time:', error);
        toast.error('Error processing your request');
    }
};

// Fonction pour gérer la confirmation de modification avec pénalité
const handleConfirmModificationWithPenalty = () => {
    // Fermer le modal d'avertissement de pénalité et ouvrir le modal de paiement
    setShowPenaltyWarningModal(false);
    setShowPaymentModal(true);
};

// Fonction pour gérer la sélection de la méthode de paiement
const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
};

// Fonction pour gérer la confirmation du paiement mobile money
const handleMomoPaymentConfirmation = async () => {
    if (paymentMethod === 'mobile-money' && !phone) {
        toast.error('Veuillez entrer votre numéro de téléphone');
        return;
    }
    
    setIsProcessingPayment(true);
    
    try {
        // Appeler l'API de traitement des paiements
        const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, {
            item_name: 'Modify appointment Payment',
            motifId: appointmentData._id,
            currency: 'USD',
            amount: penaltyAmount,
            paymentMethod: paymentMethod,
            payerMessage: "Modification fee",
            phoneNumber: phone,
            paymentReason: 'Modify appointment',
        });
        
        if (paymentResponse.status === 200) {
            // Paiement réussi, procéder à la modification
            setShowPaymentModal(false);
            await submitAppointmentModification(true, penaltyAmount, true);
            toast.success('Paiement traité avec succès');
        } else {
            toast.error('Le traitement du paiement a échoué');
        }
    } catch (error) {
        console.error('Erreur lors du traitement du paiement:', error);
        toast.error('Le traitement du paiement a échoué: ' + (error.response?.data?.message || 'Erreur inconnue'));
    } finally {
        setIsProcessingPayment(false);
    }
};

// Fonction pour traiter le paiement par carte
const handleCardPaymentConfirmation = async () => {
    if (!cardNumber || !cardExpiry || !cardCVC) {
        toast.error('Veuillez remplir tous les champs de paiement');
        return;
    }
    
    setIsProcessingPayment(true);
    
    try {
        // Appeler l'API de traitement des paiements
        const paymentResponse = await api.post('/clinic/process-penalty-payment', {
            appointmentId: appointmentData._id,
            amount: penaltyAmount,
            paymentMethod: 'card',
            cardDetails: {
                cardNumber,
                cardExpiry,
                cardCVC
            }
        });
        
        if (paymentResponse.status === 200) {
            // Paiement réussi, procéder à la modification
            setShowPaymentModal(false);
            await submitAppointmentModification(true, penaltyAmount, true);
            toast.success('Paiement traité avec succès');
        } else {
            toast.error('Le traitement du paiement a échoué');
        }
    } catch (error) {
        console.error('Erreur lors du traitement du paiement:', error);
        toast.error('Le traitement du paiement a échoué: ' + (error.response?.data?.message || 'Erreur inconnue'));
    } finally {
        setIsProcessingPayment(false);
    }
};

// Fonction pour soumettre la modification du rendez-vous
// Fonction pour soumettre la modification du rendez-vous
const submitAppointmentModification = async (lateModification, penaltyAmount, penaltyPaid) => {
    try {
        const hospitalIdToSend = appointmentData.hospitalId;
        let assignedDoctor = null;

        // Si c'est une modification tardive mais pas un patient, on annule les informations de pénalité
        if (lateModification && userRole !== "medtinz_client_patient") {
            lateModification = false;
            penaltyAmount = 0;
            penaltyPaid = false;
        }

        // if (specificDoctor) {
            // Si un médecin précis est choisi, rediriger vers la page de sélection du médecin
            navigate('/hospitaladmin/schedulerdv', {
                state: {
                    appointmentData,
                    hospitalId: hospitalIdToSend,
                    isEditing: true,
                    lateModification,
                    penaltyAmount,
                    penaltyPaid
                }
            });
            return;
        // } else {
        //     // Vérification de la disponibilité avant de soumettre
        //     assignedDoctor = await checkDoctorAvailability();

        //     // Si un médecin est trouvé, procéder à la mise à jour du rendez-vous
        //     if (assignedDoctor) {
        //         appointmentData.doctorId = assignedDoctor._id;

        //         const dataAppointment = {
        //             hospitalId: hospitalIdToSend,
        //             appointmentData,
        //             lateModification,
        //             penaltyAmount,
        //             penaltyPaid
        //         };

        //         // Mise à jour du rendez-vous
        //         const response = await api.put(`/clinic/updateappointments/${appointmentData._id}`, dataAppointment);
        //         setAppointmentInfo(response.data.appointment);

        //         // Si le prix a changé, mettre à jour le paiement
        //         if (appointmentData.price !== originalAppointment.price) {
        //             const paymentData = {
        //                 OperationId: response.data.appointment._id,
        //                 operationtype: 'Appointment Consultation Update',
        //                 operationcode: response.data.appointment.AppointmentCode,
        //                 paymentuniqueId: response.data.appointment.paymentuniqueId,
        //                 caissiereId: getUserIdFromToken(),
        //                 patientId: appointmentData.patientId,
        //                 amount: appointmentData.price,
        //                 currency: 'FCFA',
        //                 purpose: 'Consultation Fee Update',
        //                 department: appointmentData.department,
        //             };

        //             const paymentResponse = await api.post('/clinic/updatePayment', paymentData);
        //             const billingID = paymentResponse.data.billing._id;

        //             // Rediriger vers la facture si le patient est connecté
        //             if (userRole === "medtinz_client_patient" && billingID) {
        //                 navigate(`/Billings/invoiceAssurance/${billingID}`, {
        //                     state: { billingID },
        //                 });
        //             } else {
        //                 setShowSuccessModal(true);
        //             }
        //         } else {
        //             setShowSuccessModal(true);
        //             toast.success("Rendez-vous mis à jour avec succès");
        //             if (onAppointmentUpdated) {
        //                 onAppointmentUpdated(response.data.appointment);
        //             }
        //         }
        //     }
        // }
    } catch (error) {
        console.error('Erreur lors de la mise à jour du rendez-vous:', error);
        setAssignedDoctorMessage('Erreur lors de la mise à jour du rendez-vous.');
        setMessageType('danger');
        toast.error("Erreur lors de la mise à jour du rendez-vous");
    }
};

    // fermer le modal de succes
    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        onClose();
        navigate('/hospitaladmin/Appointmentlist');
    };

    // Fonction pour obtenir la date actuelle sous format YYYY-MM-DD
    const getTodayDate = () => {
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        return `${year}-${month}-${day}`;
    };

    // patients
    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds }
            });

            setPatients(response.data.patients);

        } catch (error) {
            console.error('Erreur lors de la récupération des patients:', error);
        }
    };

    // Utilisation de useEffect pour charger les données
    useEffect(() => {
        if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
            const hospitalIds = UserData.hospital_id;
            fetchPatients(hospitalIds);
        }
    }, [UserData]);

    // Mettre à jour appointmentData avec les informations du patient sélectionné
    useEffect(() => {
        if (selectedPatient) {
            const selectedPatientData = patients.find(patient => patient._id === selectedPatient);
            if (selectedPatientData) {
                setAppointmentData({
                    ...appointmentData,
                    patient_Name: `${selectedPatientData.firstname} ${selectedPatientData.lastname}`,
                    patientId: selectedPatientData._id,
                });
            }
        }
    }, [selectedPatient, patients]);

    const handlePrint = async () => {
        const element = document.querySelector('.ticketpayment');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210; // A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            pdf.save(`${appointmentInfo._id}_Apt_updated.pdf`);
        } catch (error) {
            console.error('Erreur de génération PDF:', error);
        }
    };

    if (isLoading) {
        return (
            <CModal
                alignment="center"
                scrollable
                size='lg'
                visible={visible}
                onClose={onClose}
            >
                <CModalBody className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Chargement des informations du rendez-vous...</p>
                </CModalBody>
            </CModal>
        );
    }

    return (
        <CModal
            className='newregistermodal'
            alignment="center"
            scrollable
            size='lg'
            visible={visible}
            onClose={onClose}
            aria-labelledby="EditAppointmentModal"
        >
            <CModalHeader>
                <CModalTitle id="EditAppointmentModal" className='Titleformsmodal'>Edit Appointment</CModalTitle>
            </CModalHeader>
            <CModalBody className="p-5">
                <form onSubmit={handleSubmit}>

                    {/* Sélecteur de patient, seulement visible si on vient de la page liste des rdv */}
                    <div className="form-group">
                        <label htmlFor="patient_Name">Patient Name</label>
                        {patientIdinf ? (
                            <>
                                <input
                                    type="text"
                                    value={`${patientIdinf.lastname} ${patientIdinf.firstname}`}
                                    disabled
                                />
                                <input
                                    type="hidden"
                                    name="patientId"
                                    value={patientIdinf._id || ''}
                                />
                            </>
                        ) : (
                            <select
                                name="patientId"
                                value={selectedPatient._id}
                                onChange={(e) => setSelectedPatient(e.target.value)}
                                disabled // Désactiver la modification du patient dans le cas d'une modification
                                required
                            >
                                <option value="">Select a patient</option>
                                {patients.map((patient) => (
                                    <option key={patient._id} value={patient._id}>
                                        {patient.firstname} {patient.lastname}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="hospitalId">Hospital</label>
                        {hospitalId ? (
                            <>
                                <input
                                    type="text"
                                    name="hospitalname"
                                    value={hospitalId.hospital_name || ''}
                                    disabled
                                />
                                <input
                                    type="hidden"
                                    name="hospitalId"
                                    value={hospitalId._id || ''}
                                />
                            </>
                        ) : (
                            <select
                                name="hospitalId"
                                value={appointmentData.hospitalId || ''}
                                onChange={(e) => setAppointmentData({ ...appointmentData, hospitalId: e.target.value })}
                                required
                                disabled // Désactiver la modification de l'hôpital
                            >
                                <option value="">Select Hospital</option>
                                {UserData?.hospital_id?.map(hospital => (
                                    <option key={hospital._id} value={hospital._id}>
                                        {hospital.hospital_name}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                    <div className="form-group">
                        <select
                            name="motif"
                            value={appointmentData.motif}
                            onChange={handleChange}
                            disabled
                            className="form-control"
                        >
                            <option value="Consultation">Consultation</option>
                            <option value="Control">Control</option>
                        </select>
                    </div>
                    <div className="form-group">
                        {message && <p>{message}</p>}
                        <label htmlFor="department">Department</label>
                        <select name="department" value={appointmentData?.department} disabled onChange={handleChange} required>
                            <option>Selectionner le departement</option>
                            {departments.map((department) => (
                                <option key={department._id} value={department._id}>
                                    {department.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="price">Prix</label>
                        <input
                            type="number"
                            name="price"
                            value={appointmentData?.price}
                            onChange={handleChange}
                            disabled required
                        />
                    </div>

                    <div className="form-group">
                        <textarea
                            name="notes"
                            value={appointmentData?.notes}
                            onChange={handleChange}
                            disabled
                            placeholder='Raison de la consultation'
                        ></textarea>
                    </div>

                    <div className="radiobtnapt form-group">
                        {/* <label htmlFor="specificDoctor">See specific doctor?</label> */}
                        <br></br>
                        <div className='row'>
                            {/* <div className='col'>
                                <input
                                    type="radio"
                                    name="specificDoctor"
                                    value="yes"
                                    onChange={() => setSpecificDoctor(true)}
                                    checked={specificDoctor === true}
                                />
                                Yes, I want to see a specific doctor
                            </div> */}
                            {/* <div className='col'>
                                <input
                                    type="radio"
                                    name="specificDoctor"
                                    value="no"
                                    onChange={() => setSpecificDoctor(false)}
                                    checked={specificDoctor === false}
                                />
                                No, I don't mind
                            </div> */}
                        </div>
                    </div>
                    {/* {!specificDoctor && ( */}
                        <>
                            <div className="form-group">
                                <label htmlFor="appointmentDate">Appointment Date</label>
                                <input
                                    min={getTodayDate()}
                                    type="date"
                                    name="appointmentDate"
                                    value={appointmentData?.appointmentDate ? format(new Date(appointmentData?.appointmentDate), "yyyy-MM-dd"): ""}
                                    onChange={handleDateChange}
                                    required
                                    disabled
                                />
                            </div>

                            {appointmentData?.appointmentDate && (
                                <div className="form-group">
                                    <label htmlFor="appointmentTime">Appointment Time</label>

                                    <div className="d-flex">
                                        <input
                                            type="time"
                                            name="appointmentTime"
                                            value={appointmentData?.appointmentTime}
                                            onChange={(e) => {
                                                handleChange(e);
                                                handleDateOrTimeChange();
                                            }}
                                            required
                                            disabled
                                            className="flex-grow-1 me-2"
                                        />
                                    </div>

                                    {/* <div className="available-time-slots mt-2">
                                        <CAccordion activeItemKey={showTimeSlots ? '1' : null}>
                                            <CAccordionItem itemKey="1">
                                                <CAccordionHeader onClick={() => setShowTimeSlots(!showTimeSlots)}>
                                                    <label className="text-muted mb-0">Suggested available times</label>
                                                </CAccordionHeader>
                                                <CAccordionBody>
                                                    {isLoadingTimeSlots ? (
                                                        <div className="d-flex justify-content-center">
                                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                            <span className="ms-2">Loading available time slots...</span>
                                                            </div>
                                    ) : availableTimeSlots.length > 0 ? (
                                        <div className="d-flex flex-wrap gap-2 mt-2">
                                            {availableTimeSlots.map((slot, index) => (
                                                <CButton
                                                    key={index}
                                                    size="sm"
                                                    color={appointmentData.appointmentTime === slot.start ? "primary" : "light"}
                                                    onClick={() => selectTimeSlot(slot)}
                                                    className="mb-2"
                                                >
                                                    {formatTimeForDisplay(slot.start)} - {formatTimeForDisplay(slot.end)}
                                                    <div className="small text-muted">{slot.doctorName}</div>
                                                </CButton>
                                            ))}
                                        </div>
                                    ) : appointmentData.appointmentDate ? (
                                        <div className="text-muted small mt-2">
                                            No time slots available for this date. Please try another date.
                                        </div>
                                    ) : null}
                                </CAccordionBody>
                            </CAccordionItem>
                        </CAccordion>
                    </div> */}
                </div>
            )}

            {/* Affichage du message de disponibilité */}
            {assignedDoctorMessage && (
                <div className={`alert alert-${messageType}`} role="alert">
                    {assignedDoctorMessage}
                </div>
            )}
            <br></br>

            {/* <div className="form-group">
                <label htmlFor="type_consultation">Type consultation</label>
                <select name="type_consultation" value={appointmentData.type_consultation} onChange={handleChange} required>
                    <option value="">Select Type Consultation</option>
                    <option value="inperson">In Person</option>
                    <option value="online">Telemedicine</option>
                </select>
            </div> */}
        </>
    {/* // )} */}

    <div className="savenewuser form-group d-flex justify-content-center">
        <CButton type="submit">
            Reschedule appointment &nbsp; <BsArrowRight />
        </CButton>
    </div>
</form>
</CModalBody>

<div className='timetablelast'>
    {/* Deuxième Modal */}
    {showSuccessModal && (
        <div className="modal-overlay">
            <div className="modal-content2">
                <div className='ticketpayment p-3'>
                    <div className="text-center vie mb-4 mt-3">
                        <h2 className="text-lg semibold mb-4">SUCCESS</h2>
                    </div>

                    <div className="immole">
                        <div className="text-start">
                            <p><strong>Rdv Modifié avec success</strong> </p>
                            <p>Veuillez passer a la caisse avec ce numero<strong style={{ color: 'green' }}> {appointmentInfo?.paymentuniqueId}</strong> pour effectuer votre payement</p>
                            <p><strong>Appointment Code:</strong> {appointmentInfo?.AppointmentCode}</p>
                            <p><strong>Patient :</strong> {appointmentData.patient_Name}</p>
                            <p><strong>Motif:</strong> {appointmentInfo?.motif}</p>
                            <p><strong>Type Consultation:</strong> {appointmentInfo?.type_consultation}</p>
                            <p><strong>Department:</strong> {
                                // Find the department name based on the department ID
                                departments.find(department => department._id === appointmentInfo?.department)?.name || 'N/A'
                            }</p>
                            <p><strong>Price:</strong> {appointmentInfo?.price} FCFA</p>
                            <p><strong>Notes:</strong> {appointmentInfo?.notes}</p>
                        </div>
                        <div>
                            <img src={choco} alt="choco" className="choco" />
                        </div>
                    </div>
                </div>

                <div className='mt-4 btnactionpatientcard' >
                    <CButton className="w-100" style={{ backgroundColor: '#FF9800' }} onClick={handlePrint}>
                        Telecharger<BsArrowBarDown className='ms-2' />
                    </CButton>
                    <CButton className="w-100" style={{ backgroundColor: '#28A745' }} onClick={handleCloseSuccessModal} >
                        close <BsArrowRight className='ms-2' />
                    </CButton>
                </div>
            </div>
        </div>
    )}
</div>
{/* Modal d'avertissement de pénalité */}
<CModal visible={showPenaltyWarningModal} onClose={() => setShowPenaltyWarningModal(false)}>
    <CModalHeader closeButton>
        <h5>Late Modification Warning</h5>
    </CModalHeader>
    <CModalBody>
        <div className="alert alert-warning">
            <p><strong>Warning:</strong> You are modifying this appointment less than {systemSettings.minimumModificationHours} hours before the scheduled time.</p>
            <p>A modification penalty of {systemSettings.modificationPenaltyPercentage}% will be applied.</p>
            <p>Estimated penalty amount: {penaltyAmount.toFixed(2)}</p>
        </div>
        <p>Do you wish to proceed with the modification?</p>
    </CModalBody>
    <CModalFooter>
        <CButton color="secondary" onClick={() => setShowPenaltyWarningModal(false)}>
            No, Keep Original Appointment
        </CButton>
        <CButton color="warning" onClick={handleConfirmModificationWithPenalty}>
            Confirm and Accept Penalty
        </CButton>
    </CModalFooter>
</CModal>

{/* Modal de paiement */}
<CModal visible={showPaymentModal} onClose={() => setShowPaymentModal(false)} className="payment-gateway-modal">
    <CModalHeader closeButton className="modal-header1">
        <h5>Paiement</h5>
    </CModalHeader>
    <CModalBody className="p-0">
        <div className="ret">
            <button
                className="payment-gateway-modal-close"
                onClick={() => setShowPaymentModal(false)}
            >
                ← Retour
            </button>
            <div className="paycontent">
                <div className="alert alert-info mb-4">
                    <p>Pour modifier ce rendez-vous, vous devez d'abord payer la pénalité de modification de {penaltyAmount.toFixed(2)}.</p>
                </div>
                
                <h2 className="pinta">Choisissez votre méthode de paiement</h2>
                <div className="payment-method-selection">
                    <label className="payment-method-radio">
                        <input
                            type="radio"
                            name="payment-method"
                            value="mobile-money"
                            checked={paymentMethod === 'mobile-money'}
                            onChange={() => handlePaymentMethodSelect('mobile-money')}
                        />
                        <img src={monday} alt="Mobile Money" className="monday" />
                    </label>
                    <label className="payment-method-radio">
                        <input
                            type="radio"
                            name="payment-method"
                            value="card"
                            checked={paymentMethod === 'card'}
                            onChange={() => handlePaymentMethodSelect('card')}
                        />
                        <img src={money} alt="Card Payment" className="money" />
                    </label>
                </div>
                
                {paymentMethod === 'mobile-money' && (
                    <div className="phone-input-container mobile-money-input">
                        <label>Entrez votre numéro de téléphone</label>
                        <PhoneInput
                            country={'bj'}
                            value={phone}
                            onChange={(value) => setPhoneNumber(value)}
                            name="phone"
                            className="mx-auto"
                        />
                    </div>
                )}
                
                {paymentMethod === 'card' && (
                    <>
                        <div className="mb-3">
                            <label className="form-label">Numéro de carte</label>
                            <CFormInput
                                type="text"
                                placeholder="XXXX XXXX XXXX XXXX"
                                value={cardNumber}
                                onChange={(e) => setCardNumber(e.target.value)}
                            />
                        </div>
                        
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Date d'expiration</label>
                                <CFormInput
                                    type="text"
                                    placeholder="MM/YY"
                                    value={cardExpiry}
                                    onChange={(e) => setCardExpiry(e.target.value)}
                                />
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label">CVC</label>
                                <CFormInput
                                    type="text"
                                    placeholder="123"
                                    value={cardCVC}
                                    onChange={(e) => setCardCVC(e.target.value)}
                                />
                            </div>
                        </div>
                    </>
                )}
                
                <div className="aladji">
                    <button
                        onClick={paymentMethod === 'mobile-money' ? handleMomoPaymentConfirmation : handleCardPaymentConfirmation}
                        disabled={(paymentMethod === 'mobile-money' && !phone) || isProcessingPayment}
                        className="payment-confirm-button"
                    >
                        {isProcessingPayment ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Traitement...
                            </>
                        ) : (
                            `Confirmer le Paiement (${penaltyAmount.toFixed(2)})`
                        )}
                    </button>
                    <p className="vonvon">
                        Vos données personnelles seront utilisées pour traiter votre commande, soutenir votre<br></br>
                        expérience sur ce site Web et à d'autres fins décrites<br></br>
                        dans notre politique de confidentialité.
                    </p>
                </div>
            </div>
        </div>
    </CModalBody>
</CModal>
</CModal>
   );
};

export default EditAppointmentModal;
